// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3hzQL","buttons":"PendingPaymentAlert_buttons__1wzbI"};